import React, { useEffect, useState } from "react";
import CustomizedAccordions from "../modules/Accordian";
import ModalComponent from "../modules/Modal";
import Button from "../modules/Button";
import DropSelect from "../modules/AutoComplete";
import Input from "../modules/Input";
import DocUpload from "../modules/DocUpload";
import StaticItem from "../modules/StaticItem";
import tick from "../../Assets/svg/green-bg-tick.svg";
import {
  mandatory,
  programEligibility,
  collegeEligibility,
  familyIncome,
  collegeRelated,
  docsRelated,
  technicalRelated,
  dropoutRelated,
  addressRelated,
} from "./FaqSet";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../Services";
import { registrationAPI } from "../Register/SampleJson";
import GradientLoader from "../modules/Loader";
import { addTokenInfo } from "../LoginPage/redux/actions";

function FAQ() {
  const [topic, setTopic] = useState(0);
  const [info, setInfo] = useState({ cat: "", details: "", doc: [] });
  const [dropType, setDropType] = useState("");
  const [list, setList] = useState();
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const registeredData = useSelector((state) => state.register.registeredData);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [alert, setAlert] = useState(false);
  const [uploading, setUploading] = useState(false);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const education = useSelector((state) => state.education.eduInfo);

  const dispatch = useDispatch();
  const [ModalData, setModalData] = useState({
    show: false,
    type: "",
    title: "Dropping out?",
    countDown: " ",
    desc: "",
  });

  function validateFileName(fileName) {
    // Split the file name by '.' to get the individual parts
    let name = fileName?.name;
    const parts = name?.split(".");
    console.log("in name validation", parts);
    // Check if the file name contains more than one part
    if (parts?.length > 2) {
      setModalData({ ...ModalData, show: false });
      alert("File with double extensions is not allowed.");
      fileName = null;
    }
    return fileName;
  }
  const filterDoc = (value) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "application/msword",
    ];
    let isFormat = false;
    if (value) {
      if (value !== null && value.size / 1024 / 1024 > 2) {
        value = null;
        // if (type === "admissionLetter") {
        //   showErr1(true);
        //   // setTimeout(() => showErr1(false), 3000);
        // } else {
        //   showErr2(true);
        //   // setTimeout(() => showErr2(false), 3000);
        // }
      } else {
        for (let i in allowedTypes) {
          if (value.type === allowedTypes[i]) {
            isFormat = true;
          }
        }
      }
      if (!isFormat) {
        alert("Only PDF, JPEG, PNG, and Word files are allowed.");
      }
      value = validateFileName(value);
    }
    return value;
    //dispatch(addEduInfo({ type: type, value: value }));
  };
  const CombineData = () => {
    let data = { userId: tokenData.userId };
    // console.log("in combine", personalInfo);
    let personalInfo2 = { ...personalInfo, addressProof: "" };
    let eduInfo2 = { ...education, admissionLetter: "", paymentReciept: "" };

    function filterAndRemove(obj) {
      for (let i in obj.membersList) {
        obj.membersList[i].doc = "";
        // obj.membersList[i].lastName = "";
      }

      return obj;
    }
    let incomeInfo2 = { ...filterAndRemove(incomeInfo) };
    data = {
      ...data,
      application: {
        id: tokenData.appId,
        applicationStatus: tokenData.applicationStatus,
      },
    };
    data = {
      ...data,
      application: { ...data.application, personalInfo: { ...personalInfo2 } },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        incomeInfo: { ...incomeInfo2 },
      },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        eduInfo: { ...eduInfo2 },
        salesForceApplicationId:
          tokenData.applicationData.salesForceApplicationId,
        salesforceStudentAppNumber:
          tokenData.applicationData.salesforceStudentAppNumber,
      },
      registration: { ...tokenData.registrationData },
      salesForceUserId: tokenData.salesForceUserId,
    };
    const DropoutInfo = {
      dropOut: true,
      dropoutCategory: info.cat,
      scholarshipAmountPaid: "",
      scholarshipAmountRefundUTR: "",
      scholarshipAmountRefunded: "",
      scholarshipAmountRefundStatus: "",
      dropoutStatus: "",
      reasonForDropoutRejection: "",
      reasonForDropout: info.details,
      transactionDate: "",
    };
    data = { ...data, DropoutInfo: { ...DropoutInfo } };

    return data;
  };

  const delDoc = async (id) => {
    try {
      setUploading(true);
      let item = {
        documentId: id,
      };
      const data = await api.deleteDocument(
        "application",
        tokenData?.applicationData.id,
        tokenData?.token,
        item
      );
      setUploading(false);
      getDocs();
    } catch (err) {
      alert("Sorry! Something went wrong, Please try again.");

      console.error("Error deleting document:", err);
      setUploading(false);
    }
  };

  const dropoutCall = async () => {
    try {
      const users = await api.dropout(CombineData(), tokenData.token);

      return users;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      if (error.statusCode == "403") {
        // alert(error.message)
        setAlertType({
          msg: "Sorry! Something went wrong, Please connect with administrater",
          type: "otp",
        });
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      } else if (error.statusCode == "500") {
        // alert(error.message)
        setAlertType({
          msg: error.data,
          type: "otp",
        });
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      } else {
        setAlert(true);
        setAlertType({
          msg: "Registration not successfull",
          type: "otp",
        });
        setTimeout(() => setAlert(false), 3000);
      }

      return error;
      // Handle error scenario
    }
  };

  const getDocs = async () => {
    const docs2 = await api.getDocuments(
      "application",
      tokenData.applicationData.id,
      tokenData.token
    );
    dispatch(addTokenInfo(["docs", docs2.data]));
  };

  const handleUpload = async (e) => {
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", e.doc[0]);
      formData.append("name", e.doc[0].name);
      formData.append("size", e.doc[0].size);
      formData.append("documentType", `dropout`);
      formData.append("fileType", e.doc[0].type.split("/")[1]);
      const result = await api.uploadDocument(
        "application",
        tokenData.applicationData.id,
        tokenData.token,
        formData
      );
      console.log("result", result);
      setUploading(false);
      getDocs();
      // if (docs2?.data[`currentAddressProof`]) {
      //   // addData("addressProof", "data");
      // }
    } catch (error) {
      setUploading(false);
      // alert(error.data);

      console.error("Error uploading document:", error);
    }
  };
  const showName = (name) => {
    let ext = name.split(".")[name.split(".")?.length - 1];
    name = name.replace(new RegExp("\\b" + ext + "\\b", "ig"), "");
    return (
      <div className="txt-div">
        <div className="txt-div-name">{name}</div>
        {ext}
      </div>
    );
  };
  const setConfirm = (type) => {
    return (
      <div className={`confirm-text ${type} ${dropType}`}>
        <div className="confirm-text-div">
          {dropType === "middle" && type !== "clear" ? (
            "Are you sure you would like to dropout of the Scholarship Program?"
          ) : type === "clear" ? (
            <img className="sad" src={tick} alt="happy" />
          ) : (
            "Hope you have read the FAQs regarding dropping out."
          )}
        </div>
        <div
          className={`${
            dropType === "middle" && type === "clear"
              ? "set-title"
              : "confirm-text-div"
          }`}
        >
          {
            dropType === "middle" && type !== "clear" ? (
              <>
                you can <span>view FAQs</span> regarding dropping out
              </>
            ) : dropType === "middle" && type === "clear" ? (
              "Dropout request has been initiated"
            ) : type === "clear" ? (
              "Your dropout request has been submitted."
            ) : null
            // )
            // : (
            //   <>
            //     In the meantime, you can <span>view FAQs</span> regarding dropping
            //     out
            //   </>
          }
        </div>
        <div className="confirm-text-div">
          {dropType === "middle" && type === "clear" ? (
            <div>
              You will receive an update regarding this on your registered email
              <span>{personalInfo?.email} </span>
            </div>
          ) : type === "clear" ? (
            "You’ll receive an update in your e-mail ID registered with us."
          ) : (
            dropType !== "middle" && "Would you like to drop out?"
          )}
        </div>
      </div>
    );
  };
  const setInfoData = (type, e) => {
    let info2 = info;
    info2[type] = e;
    setInfo({ ...info2 });
  };
  const setCollect = () => {
    return (
      <div className="field-set">
        <div className="field-one field">
          <DropSelect
            value={info.cat}
            onChange={(e) => setInfoData("cat", e)}
            list={[
              "I got another scholarship",
              "Dropped out of college",
              "Due to medical reasons ",
              "Took admission in another college which  is not eligible",
            ]}
            title={"Choose a category"}
            placeholder={"Search for category"}
          />
        </div>
        <div className="field-two field">
          <Input
            multiline={true}
            value={info.details}
            onChange={(e) =>
              setInfoData("details", e.replace(/[^a-zA-Z0-9. ]/g, ""))
            }
            placeholder={"Add details here"}
          />
        </div>

        <div
          className={`field-row upload  ${docs && docs?.dropout && "doc-col"}`}
        >
          {docs && docs?.dropout ? (
            <div className="doc-item">
              <StaticItem
                onChange={() => {}}
                onDelete={() => delDoc(docs?.dropout?.id)}
                isEditable={true}
                type={"doc"}
                title={"Dropout Document"}
                doc={docs?.dropout}
                docUrl={docs?.dropout?.documentUrl}
              value={docs?.dropout?.name}
                size={Math.floor(docs?.dropout?.size / 1024)}
              />
            </div>
          ) : (
            <div className="file-upload-container">
              <DocUpload
                onChange={(e) => handleUpload(filterDoc(e))}
                // footerText={"Supported formats: Word Doc, PDF, JPEG, PNG"}
                noTooltip={true}
                value={info.doc[0]}
                placeholder={"Upload documents"}
              />
              {/* {info.doc[0] && (
                <Button
                  className="upload-button"
                  onClickHandler={() => handleUpload()}
                  disabled={uploading}
                  value={
                    uploading ? <span className="spinner"></span> : "Upload"
                  }
                  type={"contained"}
                ></Button>
              )} */}
            </div>
          )}
          {/* {err && (
            <p className="set-sub-title">
              File size exceeds the maximum upload size limit.
            </p>
          )} */}
        </div>
      </div>
    );
  };
  const submitData = async () => {
    try {
      const users = await dropoutCall();
      return users;
    } catch (error) {
      alert(error.data);
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
  };

  const collectInfo = async () => {
    if (ModalData.type === "confirm") {
      setModalData({
        ...ModalData,
        show: true,
        desc: setCollect(),
        type: "collect",
      });
    } else if (ModalData.type === "collect") {
      let getDrop = await submitData();
      if (getDrop.statusCode == 200) {
        setModalData({
          ...ModalData,
          show: true,
          title: "",
          desc: setConfirm("clear"),
          type: "clear",
        });
        setInfo({ cat: "", details: "", doc: [] });
      }
    } else {
      setModalData({
        show: false,
        type: "",
        title: "Dropping out?",
        countDown: " ",
        desc: "",
      });
      // setInfo({ cat: "", details: "", doc: [] })
    }
  };

  const cancelSession = () => {
    setModalData({ ...ModalData, show: false, type: "" });
    setInfo({ cat: "", details: "", doc: [] });
  };

  useEffect(() => {
    if (ModalData.type === "collect") {
      setModalData({
        ...ModalData,
        desc: setCollect(),
      });
    }
  }, [info]);

  useEffect(() => {
    let newList = [];
    if (topic === 0) {
      newList = mandatory.item;
    } else if (topic === 1) {
      newList = programEligibility.item;
    } else if (topic === 2) {
      newList = collegeEligibility.item;
    } else if (topic === 3) {
      newList = familyIncome.item;
    } else if (topic === 4) {
      newList = collegeRelated.item;
    } else if (topic === 5) {
      newList = docsRelated.item;
    } else if (topic === 6) {
      newList = technicalRelated.item;
    } else if (topic === 7) {
      newList = dropoutRelated();
    } else {
      newList = addressRelated.item;
    }
    setList(newList);
  }, [topic]);
  useEffect(() => {
    const params = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
    let type =
      params.split("/")[params.split("/")?.length - 1].split("?")[1] ?? "";
    setDropType(type);
  }, []);
  useEffect(() => {}, [docs]);
  return (
    <div className="faq-div">
      <div className="md-title">Frequently Asked Questions</div>
      <div className="faq">
        <div className="topics">
          {[
            "Mandatory Requirements",
            "Program Eligibility & Batch Related",
            "College Eligibility Related",
            "Family Income Related",
            "College Related",
            "Documents Related",
            "Technical & Other Issues",
            "Drop out from the program",
            "Address for verification",
          ].map((item, index) => {
            return (
              <div
                onClick={() => setTopic(index)}
                className={`topic set-title pointer ${
                  index === topic ? "selected" : ""
                }`}
                key={index}
              >
                {item}
              </div>
            );
          })}
        </div>
        <div className="points">
          {list?.map((item, index) => {
            return (
              <CustomizedAccordions
                key={index}
                getDrop={() =>
                  setModalData({
                    ...ModalData,
                    show: true,
                    desc: setConfirm("confirm"),
                    type: "confirm",
                  })
                }
                question={item.question}
                list={item.answers}
              />
            );
          })}
        </div>
      </div>
      {ModalData.show && (
        <ModalComponent
          show={ModalData.show}
          handleClose={() => cancelSession()}
          title={ModalData.title}
          content={ModalData.desc}
          className="dropout-model"
          countDown={""}
        >
          <div className="modal-btn-set">
            <Button
              disabled={
                (info.cat === "" || info.details === "") &&
                ModalData.type === "collect"
              }
              onClickHandler={() => collectInfo()}
              type={ModalData.type === "collect" ?"contained" :"only-text"}
              value={
                ModalData.type === "collect"
                  ? "Submit Request"
                  : ModalData.type === "confirm"
                  ? "Yes, I would like to dropout"
                  : "Okay"
              }
            />
            {ModalData.type !== "clear" && (
              <Button
                onClickHandler={() => cancelSession()}
                type={"outlined-grey"}
                value={"Cancel"}
              />
            )}
          </div>
        </ModalComponent>
      )}
      {uploading && (
        <ModalComponent
          className={"loader-model"}
          show={uploading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default FAQ;

// topic === 6 ? (
//   <div>
//     Raise Dropout by{" "}
//     <span
//       onClick={() =>
//         setModalData({
//           ...ModalData,
//           show: true,
//           desc: setConfirm("confirm"),
//           type: "confirm",
//         })
//       }
//     >
//       clicking here
//     </span>
//   </div>
// )
